//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.Amount
import com.tixforgigs.apax.models.ItemTypeId

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The itemtype model
* 
* @param itemTypeId 
* @param additionalCharge 
* @param itemTypeName The localized itemType name
*/
@Serializable

data class ItemType (


      @SerialName(value = "itemTypeId") @Required val itemTypeId: ItemTypeId,


      @SerialName(value = "additionalCharge") val additionalCharge: Amount? = null,


      /* The localized itemType name */
    @SerialName(value = "itemTypeName") val itemTypeName: kotlin.String? = null


) {




  }

